import { atom } from "jotai"; // Jotaiのインポート

export const quizResultAtom = atom([]); // クイズの回答結果(不正解)を管理するAtom
export const quizIndexAtom = atom(0);
export const quizItemIdListAtom = atom([]); // 対象クイズのID一覧Atom
export const isAnswerAtom = atom(false);
